import { IBasketOrderPriceDiscount, IBasketOrderItem } from "../../../entities/manhattan/order/types";
import { IManhattanFactory } from "../types";
import PaymentMethods from "../../../constants/PaymentMethods";
import BasketItemsSubtotalPrice from "../../../entities/manhattan/basket/BasketItemsSubtotalPrice";
import { formatAndDividePrice } from "../../../utilites/util";


export const BasketOrderItemSubtotalMonthlyFactory: IManhattanFactory = class BasketOrderItemSubtotalMonthlyFactory {

  static create(basketItems: IBasketOrderItem[]) {
    let price = 0;
    let checkout = 0;
    let installments = 0;
    let discounts = 0;
    basketItems.forEach((item: IBasketOrderItem) => {
      if (item.price?.installmentPrice && item.price.paymentMethod === PaymentMethods.MONTHLY) {
        price = Number(item.price.installmentWithIncludedDiscount) + price;
        installments = item.price.installments;
      }

      if (item.price?.discounts) {
        discounts += +item.price.discounts?.reduce((sum: number, item: IBasketOrderPriceDiscount) => sum + Number(item.amount), 0);
      }

      if (item.price?.isPaidOnCheckout) {
        checkout = Number(item.price.amount) + checkout - item.price.discount;
      }
    });

    return new BasketItemsSubtotalPrice(
      formatAndDividePrice(price),
      formatAndDividePrice(checkout),
      installments
    );
  }

};
